// src/context/apiSlice.js
import { api } from "./api";

export const aiApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // ==========================
    // AI GENERATE
    // ==========================
    generateAiTest: builder.mutation({
      query: (body) => ({
        url: "/tests/generate",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Test", id: "LIST" }],
    }),

    // ==========================
    // MY TESTS
    // ==========================
    getMyTestById: builder.query({
      query: (id) => ({
        url: `/tests/my/${id}`,
        method: "GET",
      }),
      providesTags: (res, err, id) => [{ type: "Test", id }],
    }),

    getMyTests: builder.query({
      query: () => ({ url: "/tests/my", method: "GET" }),
      providesTags: [{ type: "Test", id: "LIST" }],
    }),

    deleteMyTest: builder.mutation({
      query: (id) => ({ url: `/tests/my/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "Test", id: "LIST" }],
    }),

    // ==========================
    // EDIT ROUTES (/api/tests/edit/...)
    // ==========================
    updateTestMeta: builder.mutation({
      query: ({ id, title, summary }) => ({
        url: `/tests/edit/${id}`,
        method: "PATCH",
        body: { title, summary },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled; // { message, test }
          dispatch(
            aiApi.util.updateQueryData("getMyTestById", arg.id, (draft) => {
              if (draft?.test) Object.assign(draft.test, data.test);
              else Object.assign(draft, data.test);
            })
          );
        } catch {}
      },
      invalidatesTags: (res, err, { id }) => [{ type: "Test", id }],
    }),

    addQuestion: builder.mutation({
      query: ({ testId, text, explanation }) => ({
        url: `/tests/edit/${testId}/questions`,
        method: "POST",
        body: { text, explanation },
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "Test", id: testId }],
    }),

    updateQuestion: builder.mutation({
      query: ({ testId, qid, text, explanation }) => ({
        url: `/tests/edit/${testId}/questions/${qid}`,
        method: "PATCH",
        body: { text, explanation },
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "Test", id: testId }],
    }),

    deleteQuestion: builder.mutation({
      query: ({ testId, qid }) => ({
        url: `/tests/edit/${testId}/questions/${qid}`,
        method: "DELETE",
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "Test", id: testId }],
    }),

    addOption: builder.mutation({
      query: ({ testId, qid, text }) => ({
        url: `/tests/edit/${testId}/questions/${qid}/options`,
        method: "POST",
        body: { text },
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "Test", id: testId }],
    }),

    updateOption: builder.mutation({
      query: ({ testId, qid, oid, text }) => ({
        url: `/tests/edit/${testId}/questions/${qid}/options/${oid}`,
        method: "PATCH",
        body: { text },
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "Test", id: testId }],
    }),

    deleteOption: builder.mutation({
      query: ({ testId, qid, oid }) => ({
        url: `/tests/edit/${testId}/questions/${qid}/options/${oid}`,
        method: "DELETE",
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "Test", id: testId }],
    }),

    setCorrectOption: builder.mutation({
      query: ({ testId, qid, optionId }) => ({
        url: `/tests/edit/${testId}/questions/${qid}/correct`,
        method: "PATCH",
        body: { optionId },
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "Test", id: testId }],
    }),

    // ==========================
    // PDF SETTINGS + EXPORT
    // ==========================
    getPdfSettings: builder.query({
      query: (testId) => ({
        url: `/tests/${testId}/pdf-settings`,
        method: "GET",
      }),
      providesTags: (res, err, testId) => [{ type: "TestPdf", id: testId }],
    }),

    updatePdfSettings: builder.mutation({
      query: ({ testId, settings }) => ({
        url: `/tests/${testId}/pdf-settings`,
        method: "PATCH",
        body: settings,
      }),
      invalidatesTags: (res, err, { testId }) => [{ type: "TestPdf", id: testId }],
    }),

    exportTestPdf: builder.mutation({
      query: ({ testId }) => ({
        url: `/tests/${testId}/export-pdf`,
        method: "GET",
        cache: "no-store",
        responseHandler: (response) => response.blob(), // ✅ PDF blob
      }),
    }),
  }),

  // ✅ bu joyi MUHIM: endpoints ichida emas!
  overrideExisting: false,
});

export const {
  useGenerateAiTestMutation,
  useGetMyTestsQuery,
  useDeleteMyTestMutation,
  useGetMyTestByIdQuery,
  useUpdateTestMetaMutation,

  // pdf
  useGetPdfSettingsQuery,
  useUpdatePdfSettingsMutation,
  useExportTestPdfMutation,

  // edit
  useAddQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  useAddOptionMutation,
  useUpdateOptionMutation,
  useDeleteOptionMutation,
  useSetCorrectOptionMutation,
} = aiApi;
